import * as React from "react";
import { Button, type ButtonProps } from "./button";
import { cn } from "@/lib/utils";

/** The ONE "＋ add something" control: a quiet accent text link (prototype `.btn.ghost`), never a plate or a dashed box.
 *  Pass the label without the plus; `plus={false}` when the translation already carries its own "＋". */
export const AddLink = React.forwardRef<HTMLButtonElement, ButtonProps & { plus?: boolean }>(
  ({ className, children, plus = true, ...props }, ref) => (
    <Button ref={ref} type="button" variant="text" size="inline" className={cn("self-start", className)} {...props}>
      {plus ? <span aria-hidden="true">＋</span> : null}
      {children}
    </Button>
  ),
);
AddLink.displayName = "AddLink";
